import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = {
  key: 0,
  class: "modal-card-title"
}
const _hoisted_5 = {
  key: 1,
  class: "modal-card-title"
}
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = { class: "enter-emails" }
const _hoisted_8 = { class: "modal-card-foot" }

import { workspacesApi } from '@/workspaces/workspaces';
import TagsInput from '@/shared/components/TagsInput.vue';
import Toast from '@/shared/services/toast';
import { PropType, ref } from 'vue';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'InviteUser',
  props: {
  workspace: {
    type: Object as PropType<WorkspaceViewModel>,
    required: false,
  },
  userTerm: {
    type: String,
    required: true,
  },
  invitePlatformAdmins: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emailRegex: RegExp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

const props = __props;

if (!props.invitePlatformAdmins && !props.workspace) {
  throw new Error('workspace is required when invitePlatformAdmins is false');
}

const updateInProgress = ref(false);
const emails = ref<string[]>([]);

const emit = __emit;

function isEmailValid(input: string) {
  return !input || emailRegex.test(input);
}

async function update(): void {
  if (updateInProgress.value) {
    return;
  }

  if (!hasEmailAddresses()) {
    Toast.showError('No valid email addresses added');
    return;
  }

  updateInProgress.value = true;
  try {
    await callApi();
    emit('close', true);
  } catch (err: any) {
    updateInProgress.value = false;
    Toast.showError(err.message);
  }
}

async function callApi() {
  if (props.invitePlatformAdmins) {
    await workspacesApi.invitePlatformAdmins(emails.value);
    Toast.showSuccess(`Successfully invited to be platform admins`);
  } else {
    await workspacesApi.inviteUsers(emails.value, props.workspace.id);
    Toast.showSuccess(`Successfully invited to ${props.workspace.name}`);
  }
}

function hasEmailAddresses() {
  return emails.value.length > 0;
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        (__props.invitePlatformAdmins)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Add users as platform admins"))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, "Add " + _toDisplayString(__props.userTerm) + "s to " + _toDisplayString(__props.workspace.name), 1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "delete",
          "aria-label": "close"
        })
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TagsInput, {
            "element-id": "whitelisted-domains",
            placeholder: "Enter a list of emails...",
            "add-tags-on-space": true,
            validation: isEmailValid,
            "validation-error-message": "This is not a valid email",
            modelValue: emails.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emails).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("footer", _hoisted_8, [
        _createVNode(_component_n_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              variant: "primary",
              disabled: !hasEmailAddresses(),
              loading: updateInProgress.value,
              onClick: update
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Send Invite ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "loading"]),
            _createVNode(_component_n_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})